import { render, staticRenderFns } from "./InstrumentListMini.vue?vue&type=template&id=f508bab8&scoped=true"
import script from "./InstrumentListMini.vue?vue&type=script&lang=ts"
export * from "./InstrumentListMini.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508bab8",
  null
  
)

export default component.exports